// extracted by mini-css-extract-plugin
export default {"desktopTimeToDestination":"RouteView_desktopTimeToDestination__7XQ7c"};